import ModalRootContainer from './containers/ModalRootContainer';

export default ModalRootContainer;
